import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SidebarCard from './SidebarCard';
import { listDirectory } from '../directory/apiDirectory';
import { moveItem } from '../directory/directoryHelpers';

/*
 * Byline: the page's author_slugs, picked from domains/<id>/authors (first is
 * the byline). Renders nothing on a domain with no authors and a page without
 * author_slugs, so sites without a directory see no change. The free-text
 * `author` field still renders on the site when author_slugs is empty.
 */
export default function AuthorsCard({ domainId, value, onChange, open, onToggle }) {
  const [authors, setAuthors] = useState(null);

  useEffect(() => {
    let cancelled = false;
    listDirectory(domainId, 'authors', { limit: 200 })
      .then((d) => { if (!cancelled) setAuthors(d.items || []); })
      .catch(() => { if (!cancelled) setAuthors([]); });
    return () => { cancelled = true; };
  }, [domainId]);

  const selected = value || [];
  if (authors === null || (authors.length === 0 && selected.length === 0)) return null;

  const name = (slug) => (authors.find((a) => a.slug === slug) || {}).name || slug;
  const available = authors.filter((a) => !selected.includes(a.slug));

  return (
    <SidebarCard id="authors" title="Authors" open={open} onToggle={onToggle}>
      {selected.length === 0 ? (
        <p className="muted small" style={{ marginTop: 0 }}>No byline. The first author added is the byline.</p>
      ) : (
        <ol style={{ margin: '0 0 8px', paddingLeft: 20 }}>
          {selected.map((slug, i) => (
            <li key={slug} style={{ marginBottom: 4 }}>
              {name(slug)}
              {i === 0 && <span className="muted small"> · byline</span>}
              {i > 0 && (
                <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange(moveItem(selected, i, 0))}>Make byline</button>
              )}
              <button type="button" className="btn btn-ghost btn-danger-text btn-sm" onClick={() => onChange(selected.filter((s) => s !== slug))}>
                Remove
              </button>
            </li>
          ))}
        </ol>
      )}
      {available.length > 0 && (
        <select
          className="select"
          aria-label="Add author"
          value=""
          onChange={(e) => { if (e.target.value) onChange([...selected, e.target.value]); }}
        >
          <option value="">+ Add author…</option>
          {available.map((a) => (
            <option key={a.slug} value={a.slug}>{a.name}{a.status === 'hidden' ? ' (hidden)' : ''}</option>
          ))}
        </select>
      )}
      <div className="hint" style={{ marginTop: 6 }}>
        <Link to={`/domain/${encodeURIComponent(domainId)}/directory?tab=authors`}>Manage authors</Link>
      </div>
    </SidebarCard>
  );
}
